var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEv3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "449.000000pt",
    height: "391.000000pt",
    viewBox: "0 0 449.000000 391.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,391.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1455 3871 c-39 -24 -260 -250 -736 -751 -211 -222 -455 -479 -542 -570 -170 -178 -185 -203 -173 -288 8 -58 29 -96 73 -129 l36 -28 574 -3 573 -2 0 366 0 366 34 34 34 34 916 -2 916 -3 27 -28 28 -27 3 -370 3 -370 568 2 568 3 36 28 c21 16 46 46 57 68 24 47 28 134 9 172 -14 26 -1263 1341 -1382 1455 l-65 62 -764 0 c-730 0 -764 -1 -793 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 2490 c-25 -11 -51 -33 -63 -52 -20 -32 -20 -46 -18 -495 l3 -461 25 -27 c50 -55 53 -55 540 -55 494 0 482 -1 534 61 l27 31 -3 468 -3 469 -28 29 c-48 50 -70 52 -538 52 -406 0 -437 -2 -476 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 1783 c-84 -41 -126 -159 -88 -246 12 -28 108 -132 411 -447 50 -52 262 -275 471 -495 210 -220 416 -433 458 -473 132 -125 30 -112 886 -112 566 1 750 4 766 13 65 38 102 75 1259 1291 99 103 186 200 194 213 8 17 12 48 9 89 -3 50 -10 72 -33 105 -59 83 -28 79 -657 79 l-558 0 0 -357 c0 -340 -1 -360 -20 -391 -11 -18 -32 -37 -46 -42 -40 -15 -1806 -13 -1839 2 -53 24 -55 36 -55 428 l0 360 -562 0 c-498 0 -567 -2 -596 -17z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEv3);
export default __webpack_public_path__ + "static/media/ev3.87c4bb4b6c3f774a2c2f4b0efb68d007.svg";
export { ForwardRef as ReactComponent };